import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip'

const HelpMessage = ({ message, id }) => {
  if (message.length > 0) {
    return (
      <span data-tip data-for={id} className="text-input-label-help">
        <FontAwesomeIcon icon={faQuestionCircle} />
        <ReactTooltip id={id} type="dark" effect="solid" place="top">
          <p style={{ maxWidth: '200px' }}>{message}</p>
        </ReactTooltip>
      </span>
    )
  }

  return null
}

HelpMessage.defaultProps = { message: '' }
export default HelpMessage
